import React from 'react';

const BaseSizeAndQtyModal = ({
	handleChange,
	validateNumber,
	qtyError,
	inputData,
	validateFloatNumber,
	handleUpdate,
	handleClose,
	sizeError,
	onPriceInputFocus,
	onPriceInputBlur,
	onPriceInputChange
}) => {
	return (
		<div className="base-size-and-quantity">
			<div className="size-and-quantity-details">
				<p className="regular-14 gray_dark_01 mb-2">Base size & qty</p>
				<div className="inputs d-flex">
					<input
						type="number"
						placeholder="Qty"
						name="moq"
						onKeyPress={validateNumber}
						onChange={handleChange}
						value={inputData?.moq || ''}
						className={qtyError ? 'common-border-error' : ''}
					/>
					<input
						type="text"
						autoComplete="off"
						placeholder="Size"
						name="baseSize"
						onChange={handleChange}
						value={inputData?.baseSize || ''}
						className={sizeError ? 'common-border-error' : ''}
					/>

					<input
						type="number"
						placeholder="Price"
						name="totalCost"
						onFocus={onPriceInputFocus}
						onBlur={onPriceInputBlur}
						onKeyPress={validateFloatNumber}
						onChange={onPriceInputChange || handleChange}
						value={inputData.totalCost ?? ''}
					/>
				</div>
			</div>
			<div className="footer-buttons text-right mt-2">
				<span onClick={handleClose} className="regular-14 gray_dark_02 cursor-pointer">
					CANCEL
				</span>
				<span
					className="regular-14 primary_bright_01 ml-3 cursor-pointer"
					onClick={() => handleUpdate(true)}
				>
					UPDATE
				</span>
			</div>
		</div>
	);
};

export default BaseSizeAndQtyModal;
